import { API_REQUEST } from "../..";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  adminProjectAPI,
  adminJobApplicationsAPI,
  adminJobApplicationJobsAPI,
  updateProjectStatusEndPointURL,
  adminProjectDetailsAPI,
  adminProjectFreelancerAPI,
  inviteToProjectAPI,
  addAdminProjectEndPointURL,
  markAdminProjectCompleteEndPointURL,
  uploadDeliveableProjectAdminEndPointURL,
  fetchAdminDeliveableProjectDetailsEndPointURL,
} from "../../../../routes/apiurls";

export const fetchAdminProject = createAsyncThunk("fetch-admin-project", async () => {
  try {
    const response = await API_REQUEST({
      url: adminProjectAPI,
      method: "GET",
      isSuccessToast: false,
    });
    return response;
  } catch (error) { }
});

export const updateProjectStatus = createAsyncThunk("update-project-status", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: updateProjectStatusEndPointURL,
      method: "PUT",
      data: payload,
    });
    callback(response);
    return response;
  } catch (error) {
    callback(error, null);
  }
});

// fetch-project-details
export const fetchProjectDetails = createAsyncThunk(
  "fetch-project-details",
  async (props) => {
    try {
      const { payload } = props || {};
      const response = await API_REQUEST({
        url: adminProjectDetailsAPI + payload,
        method: "GET",
      });
      return response;
    } catch (error) { }
  }
);

// admin/project/deliverables/
export const fetchProjectUploadeableDetails = createAsyncThunk(
  "fetch-uploadeable-project-details",
  async (props) => {
    try {
      const { payload } = props || {};
      const response = await API_REQUEST({
        url: fetchAdminDeliveableProjectDetailsEndPointURL + payload,
        method: "GET",
      });
      return response;
    } catch (error) { }
  }
);

// fetch-project-freelancer
export const fetchProjectFreelancer = createAsyncThunk(
  "fetch-project-freelancer",
  async (props) => {
    try {
      const { payload } = props || {};
      const response = await API_REQUEST({
        url: adminProjectFreelancerAPI + payload,
        method: "GET",
      });
      return response;
    } catch (error) { }
  }
);

export const inviteToProject = createAsyncThunk("invite-to-project", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: inviteToProjectAPI,
      method: "POST",
      data: payload,
    });
    callback(response);
    return response;
  } catch (error) {
    callback(error, null);
  }
});

export const addAdminProjectDetails = createAsyncThunk("admin-project-add", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: addAdminProjectEndPointURL,
      method: "POST",
      data: payload,
    });
    callback(response);
    return response;
  } catch (error) {
    callback(error, null);
  }
});

export const markAdminProjectComplete = createAsyncThunk("admin-project-complete", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: markAdminProjectCompleteEndPointURL,
      method: "POST",
      data: payload,
    });
    callback(response);
    return response;
  } catch (error) {
    callback(error, null);
  };
});

export const uploadDocumentByAdmin = createAsyncThunk("admin-upload-doc", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: uploadDeliveableProjectAdminEndPointURL,
      method: "POST",
      data: payload,
    });
    callback(response);
    return response;
  } catch (error) {
    callback(error, null);
  };
});

export const fetchAdminJobApplications = createAsyncThunk(
  "fetch-admin-job-applications",
  async (props) => {
    try {
      const { job_id, tab = "all" } = props || {};
      const response = await API_REQUEST({
        url: adminJobApplicationsAPI,
        method: "GET",
        params: {
          tab,
          ...(job_id ? { job_id } : {}),
        },
        isSuccessToast: false,
      });
      return response;
    } catch (error) { }
  }
);

export const fetchAdminJobApplicationJobs = createAsyncThunk(
  "fetch-admin-job-application-jobs",
  async () => {
    try {
      const response = await API_REQUEST({
        url: adminJobApplicationJobsAPI,
        method: "GET",
        isSuccessToast: false,
      });
      return response;
    } catch (error) { }
  }
);
